
export default{
    //保存用户信息
    saveInfo({commit}, {userName, roles, leaderFirst, staffCode, staffStatus}) {
        commit('setUserName', userName);
        commit('setRoles', roles); 
        commit('setLeaderFirst', leaderFirst); 
        commit('setStaffCode', staffCode); 
        commit('setStaffStatus', staffStatus)
    },
    //获取tokens;
    saveTokens({commit},tokens){
        commit('setTokens', tokens);
    },

   
}


// WEBPACK FOOTER //
// ./src/store/actions.js